import WithPortalAuthorization from '@hocs/WithPortalAuthorization'
import { RegionalUserDashboard } from '@layouts/Scheduling/Instructors/PageComponents'
import React from 'react'

const SFStandardDashboard: React.FC = () => <RegionalUserDashboard baseRoute={'/sfstandard/instructors'} />

export default WithPortalAuthorization(SFStandardDashboard, {
  id: 'page::sfstandard::dashboard',
  queryParams: ['ie', 'sid', 'path'],
})
